import { injectTranslate } from '@recruitee/i18n';
import { textCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const departmentColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Department,
  label: injectTranslate()('app.offers.table.department'),
  visible: true,
  geometry: {
    width: 110,
    minWidth: 110,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('department'),
}));
